import { Link } from "wouter";
import RightArrowSvg from "../RightArrowSvg/RightArrowSvg";
import "./LinkWithArrow.scss";

const LinkWithArrow = ({ linkRoute, linkText, data }) => {
	return (
		<Link href={linkRoute ? linkRoute : ""} data={data}>
			<div className="linkWithArrow--container">
				<p className="body-14 bold c-light-blue" id="linkWithArrow--link-text">
					{linkText}
				</p>
				<div className="linkWithArrow--svg-container">
					<RightArrowSvg />
				</div>
			</div>
		</Link>
	);
};

export default LinkWithArrow;
